'use es6';

import { createAction } from '@reduxjs/toolkit';
import { DISMISS_ATTACHMENTS_ERROR } from '../constants/fileUploadsActionTypes';
export const dismissAttachmentsError = createAction(DISMISS_ATTACHMENTS_ERROR, ({
  threadId
}) => ({
  payload: {
    threadId
  }
}));